import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/usuarios/gmail-credentials/";

/**
 * Obtiene las credenciales de Gmail del usuario actual.
 * Respuesta esperada:
 * {
 *   gmail_email: string | null,
 *   has_app_password: boolean,
 *   gmail_config_updated_at: string | null
 * }
 */
export async function getGmailCredentials() {
  const response = await axiosInstance.get(BASE_URL);
  return response.data;
}

/**
 * Actualiza las credenciales de Gmail del usuario actual.
 * @param {{ gmail_email?: string|null, gmail_app_password?: string|null }} payload
 *    - gmail_email: correo a registrar (puede ser null para limpiar)
 *    - gmail_app_password: contraseña de aplicación de Gmail (plain); si null limpia el valor
 */
export async function updateGmailCredentials(payload) {
  const response = await axiosInstance.patch(BASE_URL, payload);
  return response.data;
}
